import { SET_START_DATE, SET_END_DATE, SET_MOSTRAR } from '../../actions/fuse/documents.actions';


const initialState = {
  startDate: new Date(),
  endDate: new Date(),
  mostrar: null
};

const documents = (state = initialState, action) => {
  switch (action.type) {
    case SET_START_DATE:
      return {
        ...state,
        startDate: action.payload,
      };
    case SET_END_DATE:
      return {
        ...state,
        endDate: action.payload,
      };
    case SET_MOSTRAR:
      return {
        ...state,
        mostrar: action.payload,
      };
    default:
      return state;
  }
};

export default documents;
